import { render } from "./PilaLegal.vue?vue&type=template&id=0c95ba56&scoped=true"
import script from "./PilaLegal.vue?vue&type=script&lang=js"
export * from "./PilaLegal.vue?vue&type=script&lang=js"

import "./PilaLegal.vue?vue&type=style&index=0&id=0c95ba56&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c95ba56"]])

export default __exports__